import { authApi } from './authApi'
import {
  SignInDTO,
  VerifyCodeDTO,
  VerifyPasswordDTO,
  SocialSignIndDTO,
  SetupPasswordDTO,
  SetupProfileDTO,
  SignInWithPhonePayload,
  SignInWithEmailPayload,
  SocialSignInPayload,
  CheckCodeSentToPhonePayload,
  CheckCodeSentToEmailPayload,
  SendCodeToPhonePayload,
  SendCodeToPhoneDTO,
  VerifyPasswordPayload,
  SetupPasswordPayload,
  SetupProfilePayload,
  SendRecoveryCodeToEmailPayload,
  RecoveryCodeDTO,
  CheckRecoveryCodeSentToEmailPayload,
  CheckRecoveryCodeSentToPhonePayload,
  SendRecoveryCodeToPhonePayload,
  RecoverPasswordPayload,
  RecoverPasswordDTO,
} from './authTypes'

// ======== PHONE AUTH ==============
async function signInWithPhone(
  payload: SignInWithPhonePayload,
): Promise<SignInDTO> {
  return authApi.signInWithPhone(payload)
}

async function sendCodeToPhone(
  payload: SendCodeToPhonePayload,
): Promise<SendCodeToPhoneDTO> {
  return authApi.sendCodeToPhone(payload)
}

async function checkCodeSentToPhone(
  payload: CheckCodeSentToPhonePayload,
): Promise<VerifyCodeDTO> {
  return authApi.checkCodeSentToPhone(payload)
}

// ======== EMAIL AUTH ==============
async function signInWithEmail(
  payload: SignInWithEmailPayload,
): Promise<SignInDTO> {
  return authApi.signInWithEmail(payload)
}

async function checkCodeSentToEmail(
  payload: CheckCodeSentToEmailPayload,
): Promise<VerifyCodeDTO> {
  return authApi.checkCodeSentToEmail(payload)
}

// ======== SOCIAL AUTH ==============
async function signInWithApple(
  payload: SocialSignInPayload,
): Promise<SocialSignIndDTO> {
  return authApi.signInWithApple(payload)
}

async function signInWithGoogle(
  payload: SocialSignInPayload,
): Promise<SocialSignIndDTO> {
  return authApi.signInWithGoogle(payload)
}

// ======== PASSWORD ==============
async function verifyPassword(
  payload: VerifyPasswordPayload,
): Promise<VerifyPasswordDTO> {
  return authApi.verifyPassword(payload)
}

async function setupPassword(
  payload: SetupPasswordPayload,
): Promise<SetupPasswordDTO> {
  return authApi.setupPassword(payload)
}

// ======== PROFILE ==============
async function setupProfile(
  payload: SetupProfilePayload,
): Promise<SetupProfileDTO> {
  return authApi.setupProfile(payload)
}

// ======== LOGOUT ==============
async function logout(): Promise<unknown> {
  return authApi.logout()
}

// ======== RECOVERY CODE WITH EMAIL ==============
async function sendRecoveryCodeToEmail(
  payload: SendRecoveryCodeToEmailPayload,
): Promise<RecoveryCodeDTO> {
  return authApi.sendRecoveryCodeToEmail(payload)
}

async function checkRecoveryCodeSentToEmail(
  payload: CheckRecoveryCodeSentToEmailPayload,
): Promise<VerifyCodeDTO> {
  return authApi.checkRecoveryCodeSentToEmail(payload)
}
// ======== RECOVERY CODE WITH PHONE ==============
async function sendRecoveryCodeToPhone(
  payload: SendRecoveryCodeToPhonePayload,
): Promise<RecoveryCodeDTO> {
  return authApi.sendRecoveryCodeToPhone(payload)
}

async function checkRecoveryCodeSentToPhone(
  payload: CheckRecoveryCodeSentToPhonePayload,
): Promise<VerifyCodeDTO> {
  return authApi.checkRecoveryCodeSentToPhone(payload)
}

// ======== RECOVER PASSWORD ==============
async function recoverPassword(
  payload: RecoverPasswordPayload,
): Promise<RecoverPasswordDTO> {
  return authApi.recoverPassword(payload)
}

export const authServices = {
  signInWithPhone,
  sendCodeToPhone,
  checkCodeSentToPhone,
  signInWithEmail,
  checkCodeSentToEmail,
  signInWithApple,
  signInWithGoogle,
  verifyPassword,
  setupPassword,
  setupProfile,
  logout,
  sendRecoveryCodeToEmail,
  checkRecoveryCodeSentToEmail,
  sendRecoveryCodeToPhone,
  checkRecoveryCodeSentToPhone,
  recoverPassword,
}
